import { render, staticRenderFns } from "./shotsByTensionBeatsModal.vue?vue&type=template&id=658f1b1a"
import script from "./shotsByTensionBeatsModal.vue?vue&type=script&lang=js"
export * from "./shotsByTensionBeatsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports